export const fmtIST = (iso) =>
  iso ? `${new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", weekday: "short", day: "2-digit", month: "short", hour: "numeric", minute: "2-digit" })} IST` : "—";
